var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquityBrokerageMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1286 10.2637H13.8833C13.5631 10.2637 13.2559 10.3909 13.0295 10.6174C12.803 10.8438 12.6758 11.151 12.6758 11.4712V18.7165C12.6758 19.0368 12.803 19.3439 13.0295 19.5704C13.2559 19.7968 13.5631 19.924 13.8833 19.924H21.1286C21.4489 19.924 21.756 19.7968 21.9825 19.5704C22.2089 19.3439 22.3362 19.0368 22.3362 18.7165V11.4712C22.3362 11.151 22.2089 10.8438 21.9825 10.6174C21.756 10.3909 21.4489 10.2637 21.1286 10.2637ZM17.506 11.7731C17.9063 11.7731 18.2902 11.9321 18.5733 12.2152C18.8564 12.4983 19.0154 12.8822 19.0154 13.2825C19.0154 13.6829 18.8564 14.0668 18.5733 14.3499C18.2902 14.6329 17.9063 14.792 17.506 14.792C17.1056 14.792 16.7217 14.6329 16.4386 14.3499C16.1556 14.0668 15.9965 13.6829 15.9965 13.2825C15.9965 12.8822 16.1556 12.4983 16.4386 12.2152C16.7217 11.9321 17.1056 11.7731 17.506 11.7731ZM20.5248 18.1127H14.4871V17.9618C14.4871 16.8454 15.848 15.6976 17.506 15.6976C19.1639 15.6976 20.5248 16.8454 20.5248 17.9618V18.1127Z",
    fill: "#8EB111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4693 13.8857H10.2617V21.131C10.2617 21.797 10.8033 22.3386 11.4693 22.3386H18.7145V21.131H11.4693V13.8857Z",
    fill: "#8EB111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityBrokerageMobileLogo);
export default __webpack_public_path__ + "static/media/equity_brokerage_mobile_logo.e73a6e0efe0b23d193feb9b4732f57bf.svg";
export { ForwardRef as ReactComponent };